import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { deleteVendors, getVendors } from '../../../MyApi/vendors'
import DataTable from '../../UI/table/DataTable'
import StatusBadge from '../../UI/statusBadge'
import TableActions from '../../UI/table/TableActions'
import LoadingSpinner from '../../UI/spinner'
import AddEmployeeModal from '../vendorStore'

const EmployeInfo = ({id ,name}) => {
    const [currentPage,setCurrentPage]=useState(1)
    const [isModalOpen ,setIsModalOpen]=useState(false)
    const {data,isLoading ,refetch}=useQuery(["getVendors",currentPage],()=>getVendors(id))
    const  vendors= data?.data?.vendors ||[]
    const totalItems =data?.data?.pagination?.total;
    const lastPage=data?.data?.pagination?.last_page;
   
   
const handleOpenVendorModal =()=>{
setIsModalOpen(true)
}

  const employeColumns = [
    { label: "الاسم كامل", accessor: "full_name" },
    { label: "الدور", accessor: "role" },
    { label: "الفرع", accessor: "phone" },
    { label: "الإيميل", accessor: "email" },
    { label: "رقم الجوال", accessor: "phone" },
    { label: "تاريخ أخر تسجيل", accessor: "last_login" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: () => <TableActions viewPermission={"view_vendor"}  deleteFn={deleteVendors} deletePermission={"delete_vendor"} />,
    },
  ];
 
  return (
    <div>
    {isModalOpen &&  <AddEmployeeModal   refetch={refetch} onClose={()=>setIsModalOpen(false)} show={isModalOpen}  store_id={id}  store_name={name}  modalMode={"add"} />}
        <DataTable data={vendors} 
         isLoading={isLoading} title={"الموظفين"}   columns={employeColumns} onAddClick={handleOpenVendorModal} createPermission={"create_vendor"} actionLabel={"إضافة موظف"} currentPage={currentPage} setCurrentPage={setCurrentPage} totalItems={totalItems} itemsPerPage={lastPage}/>
    </div>
  )
}

export default EmployeInfo